import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  image: {
    maxWidth: 320,
  },
}));

export default useStyles;
